import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const webResUpdateAfterMargedCustomerSlice = createSlice({
  name: 'webResUpdateAfterMargedCustomer',
  initialState: { webResUpdateAfterMargedCustomer: initialState },
  reducers: {
    webResUpdateAfterMargedCustomerApi: (state, data) => {
      state.webResUpdateAfterMargedCustomer = data.payload;
    },
  },
});

export const { webResUpdateAfterMargedCustomerApi } = webResUpdateAfterMargedCustomerSlice.actions;

export default webResUpdateAfterMargedCustomerSlice.reducer;
